import React from 'react';
import Button from '@atlaskit/button';
import StarFilledIcon from '@atlaskit/icon/glyph/star-filled';
import StarIcon from '@atlaskit/icon/glyph/star';
import Tooltip from '@atlaskit/tooltip';
interface FavouritesProps {
  isFavorited: boolean;
  entityName?: any;
  metadata?: any;
  handleFavoriteToggle: (entityName: string, metadata: any) => void;
}
export const FavouriteButton = ({ isFavorited, entityName, metadata, handleFavoriteToggle }: FavouritesProps) => {
  return (
    <Tooltip content={isFavorited ? 'Unstar this page' : 'Star this page'} position="bottom">
      <Button
        appearance="subtle"
        onClick={() => {
          handleFavoriteToggle(entityName, metadata);
        }}
        data-testId="mark-favourite"
        iconBefore={
          isFavorited ? <StarFilledIcon label="star-filled" primaryColor="#FFC400" /> : <StarIcon label="star-icon" />
        }
      ></Button>
    </Tooltip>
  );
};
